module.exports = __webpack_public_path__ + "img/climate_smart_winery.8b7c918b.jpg";